(ns app.front.view.group.admin.feature-toggle
  (:require [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [app.front.ui.yes-no-radio-buttons :as yes-no]
            [app.front.util :as futil]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::toggle-group-feature-success
  (fn [_ [_ status additional-entity-db]]
    {:dispatch-n [[::entities/apply-changes status additional-entity-db]
                  [:notifications/add :toast :success :changes-saved ""]]}))


(rf/reg-event-fx ::toggle-group-feature
  (fn [_ [_ group-id feature enabled? current-group-version]]
    {:comm/command {:command    :group/toggle-group-feature
                    :data       (p/assoc-if
                                  {:group-id group-id
                                   :feature  feature
                                   :enabled? enabled?}
                                  :entity/version current-group-version)
                    :on-success [::toggle-group-feature-success]}}))


(defn title-kw [kw]
  (keyword (str (namespace kw) ".title")
           (name kw)))


(defn toggle-group-feature [{:keys [tr feature-name check-subfeature-issues? feature-flag
                                    inverted? disabled? disabled-reason]}]
  (let [group-id       (<sub [::gas/group-id])
        group-features (<sub [::gas/group-features])
        feature-flag?  (or (nil? feature-flag)
                           (<sub [::ff/enabled? feature-flag]))
        toggled?       (contains? group-features feature-name)
        enabled?       (if inverted? (not toggled?) toggled?)
        disable-issue  (group-model/disable-feature-issue {:group/features group-features} feature-name)]
    (when feature-flag?
      [:div
       [:h3.w-full.mb-2 (tr [(title-kw feature-name)])]
       [:div.mb-4
        [:div.mb-2.text-xs (tr [feature-name])]
        (when disabled-reason
          [:div.mb-2.text-xs disabled-reason])
        [yes-no/yes-no-radio-buttons tr (futil/sanitize-id feature-name)
         {:value-selected enabled?
          :disabled       (boolean (or disabled? (and toggled? check-subfeature-issues? disable-issue)))
          :on-change      (fn [enabled?]
                            (>evt [::toggle-group-feature group-id feature-name
                                   (if inverted? (not enabled?) enabled?)]))}]]])))
